'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderNumericConstants = exports.OrderList = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderList = exports.OrderList = (0, _keymirror2.default)({
    PERSONAL_ORDER_LIST_LOAD: null,
    PERSONAL_ORDER_LIST_SUCCESS: null,
    PERSONAL_ORDER_LIST_FAIL: null,

    ORDER_SETTING_SUCCESS: null,
    ORDER_SETTING_SEND: null,
    ORDER_SETTING_FAIL: null,

    ORDER_SET_FAIL: null
});

var OrderNumericConstants = exports.OrderNumericConstants = {
    ORDERS_PAGE_LIMIT: 12
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/personal/order_list.js
// module id = 1878
// module chunks = 0